<template>
  <div
    class="paintings-slider"
    @click="cursorGoTo"
    :style="{
      cursor: cursor
    }"
  >
    <div ref="container" :style="{ height: '100%', width: '100%' }">
      <TvaSlider
        :config="{ arrows: false, dots: false }"
        @change="changePaint"
        :startIndex="getPaint.index"
        :sliderGoTo="sliderGoTo"
        :cursor="false"
      >
        <div
          v-for="paint in $ml.get('data')"
          :key="paint.id"
          @mousemove="changeCursor"
          @mouseleave="cursor = 'initial'"
          :class="[
            'slide',
            {
              selected: paint.index === getPaint.index,
              prevTwo: paint.index === getPaint.index - 2,
              prevOne: paint.index === getPaint.index - 1,
              nextOne: paint.index === getPaint.index + 1,
              nextTwo: paint.index === getPaint.index + 2,
              outside:
                paint.index > getPaint.index + 2 ||
                paint.index < getPaint.index - 2
            }
          ]"
        >
          <img
            :style="{
              opacity: paint.shape === 'rettangolo' ? 1 : 0,
              height:
                paint.height / paint.width < 0.9 && $tvaMq === 'mobile'
                  ? '60%'
                  : '100%'
            }"
            :class="['image']"
            :data-flickity-lazyload="src(paint)"
          />

          <svg
            class="svg"
            v-if="paint.shape !== 'rettangolo'"
            :width="height * (paint.width / paint.height) + 'px'"
            height="100%"
            :style="{
              left: `calc(50% - ${(height * (paint.width / paint.height)) /
                2}px`
            }"
            :viewBox="
              `0 0 ${masks[paint.id].artBoard.width} ${
                masks[paint.id].artBoard.height
              }`
            "
          >
            <defs>
              <clipPath :id="`svgPath-${paint.id}`">
                <path :d="masks[paint.id].path" />
              </clipPath>
            </defs>
            <image
              :clip-path="`url(#svgPath-${paint.id})`"
              height="100%"
              width="100%"
              :xlink:href="src(paint)"
            />
          </svg>
        </div>
      </TvaSlider>
    </div>
  </div>
</template>

<script>
import TvaSlider from "@/utilities/TvaSlider.vue";
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import masks from "@/assets/content/masks.json";
export default {
  name: "paintings-slider",
  props: ["paintingSliderGoTo"],
  created() {
    this.viewportWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      this.viewportWidth = window.innerWidth;
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.height = this.$refs.container.getBoundingClientRect().height;
    });
  },
  computed: {
    ...mapGetters(["getPaint", "getCountry"])
  },
  watch: {
    paintingSliderGoTo(value) {
      this.sliderGoTo = value;
    },
    getCountry() {
      this.sliderGoTo = this.getPaint.index;
    }
  },
  data() {
    return {
      height: 0,
      cursor: "inital",
      viewportWidth: 0,
      sliderGoTo: null,
      masks,
      baseUrl: process.env.BASE_URL
    };
  },
  methods: {
    src(paint) {
      let folder = "";
      if (this.$tvaMq === "desktop" || this.$tvaMq === "tablet") {
        if (paint.width < 300) {
          folder = "500";
        } else {
          folder = "800";
        }
      } else if (this.$tvaMq === "large") {
        folder = "800";
      } else {
        if (paint.width < 300) {
          folder = "300";
        } else {
          folder = "500";
        }
      }

      return `${this.baseUrl}assets/paintings/${folder}/${paint.id}-0.jpg`;
    },
    changeCursor(e) {
      if (e.clientX < this.viewportWidth / 2) {
        this.cursor = `url('${this.baseUrl}assets/images/left.png'), auto`;
      } else {
        this.cursor = `url('${this.baseUrl}assets/images/right.png'), auto`;
      }
    },
    cursorGoTo(e) {
      if (e.clientX < this.viewportWidth / 2) {
        if (this.getPaint.index > 0) {
          this.sliderGoTo = this.getPaint.index - 1;
        }
      } else {
        if (
          this.getPaint.index <
          this.$ml.get("data")[this.$ml.get("data").length - 1].index
        ) {
          this.sliderGoTo = this.getPaint.index + 1;
        }
      }
    },
    changePaint(index) {
      let paint = _.find(this.$ml.get("data"), paint => paint.index === index);
      this.setPaint(paint);
    },
    ...mapActions(["setPaint"])
  },
  components: {
    TvaSlider
  }
};
</script>

<style lang="scss" scoped>
.paintings-slider {
  width: 100%;
  height: calc(100% - 100px);
  padding: 110px 0 30px;
  @media (max-width: 720px) {
    height: calc(95% - 100px);
    padding: 120px 0 40px;
  }
  animation: fadeIn 0.3s;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .slide {
    height: 100%;
    // height: 342px;
    transition: all 0.3s ease;
    position: relative;
    .svg {
      position: absolute;
      top: 0;
      left: 0;
    }
    &.prevTwo {
      opacity: 0.3;
      transform: translateX(40%) scale(0.6);
      transform-origin: 50% 50%;
      z-index: 0;
    }
    &.prevOne {
      opacity: 0.7;
      transform: translateX(10%) scale(0.8);
      transform-origin: 50% 50%;
      z-index: 1;
    }
    &.nextTwo {
      opacity: 0.3;
      transform: translateX(-40%) scale(0.6);
      transform-origin: 50% 50%;
      z-index: 0;
    }
    &.nextOne {
      opacity: 0.7;
      transform: translateX(-20%) scale(0.8);
      transform-origin: 50% 50%;
      z-index: 1;
    }
    &.outside {
      opacity: 0;
    }
    &.selected {
      z-index: 2;
    }
    .image {
      height: 100%;
    }
  }
}
</style>
